// src/components/sections/MoreDeskDelightsSection.jsx
import { Link } from "react-router-dom";

// Har category ka naam uske page route se map kiya hua hai
// Apne actual routes ke hisaab se in paths ko adjust kar lena
const categories = [
  { name: "Dairy",                   path: "/Dailyplanner" },
  { name: "Photo book",              path: "/photobook" },
  
  { name: "Journal",                 path: "/gratitude-journals" },
  { name: "Notebook",                path: "/notebooks" },
  { name: "Notepad",                 path: "/list-notepads" },
  { name: "Table calander",          path: "/travel-planner" },
   { name: "Planner",                 path: "/productivityplanner" },
  { name: "Corporate gift hampers",  path: "/gift-hampers" },
  { name: "Sketcbook",               path: "/bold-bright" },
];

const MoreDeskDelightsSection = ({ onCategoryClick }) => {
  const topCategories = categories.slice(0, 7);
  const bottomCategories = categories.slice(7);

  return (
    <section className="bg-white py-6 sm:py-8 md:py-10 px-3 sm:px-4 md:px-10 font-body">
      <div className="max-w-[1300px] mx-auto text-center">

        <h2 className="font-serif text-[19px] xs:text-[22px] sm:text-[28px] md:text-[34px] font-normal text-[#111] mb-4 sm:mb-8 tracking-tight">
          More desk delights
        </h2>

        <div className="flex flex-col items-center gap-1.5 sm:gap-3">

          <div className="flex flex-wrap justify-center gap-1.5 sm:gap-2.5">
            {topCategories.map((cat) => (
              <Link
                key={cat.name}
                to={cat.path}
                onClick={() => onCategoryClick?.(cat.name)}
                className="px-2.5 py-1.5 sm:px-5 sm:py-2.5 border-[1.5px] border-[#111] bg-transparent text-[10px] xs:text-[11.5px] sm:text-[13px] font-semibold text-[#111] hover:bg-[#111] hover:text-white transition-colors duration-200 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="flex flex-wrap justify-center gap-1.5 sm:gap-2.5">
            {bottomCategories.map((cat) => (
              <Link
                key={cat.name}
                to={cat.path}
                onClick={() => onCategoryClick?.(cat.name)}
                className="px-2.5 py-1.5 sm:px-5 sm:py-2.5 border-[1.5px] border-[#111] bg-transparent text-[10px] xs:text-[11.5px] sm:text-[13px] font-semibold text-[#111] hover:bg-[#111] hover:text-white transition-colors duration-200 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
};

export default MoreDeskDelightsSection;